import { externalData } from '@amazon/vinyl-observable'
import type { Unsubscribe } from '@amazon/vinyl-util'
import type { LifecycleSource } from '../env/PlaybackEnv'

function listen(target: EventTarget, type: string, callback: () => void): Unsubscribe {
    target.addEventListener(type, callback)
    return () => target.removeEventListener(type, callback)
}

const isHidden = () => document.visibilityState === 'hidden'

export const pageLifecycle: LifecycleSource = {
    get hidden$() {
        return externalData(isHidden(), (setData) => {
            const sync = () => setData(isHidden())
            sync()
            return listen(document, 'visibilitychange', sync)
        })
    },
    onTerminate: (callback) => listen(window, 'pagehide', callback),
    onResume: (callback) => listen(window, 'pageshow', callback),
}
